/**
 * True when Core returned a PAGS deadline that is still in the future per `Date` vs `Date.now()`.
 * Shared by MMS auth, REST permission logic, and `GamePlayControlServiceClient`.
 */
export function isPlayAfterGameShowActive(playAfterGameShowUntil: string | null | undefined): boolean {
  if (!playAfterGameShowUntil) { return false; }
  return new Date(playAfterGameShowUntil).getTime() > Date.now();
}
